import { render, staticRenderFns } from "./mainleftcustomer.vue?vue&type=template&id=310d287c&scoped=true&"
import script from "./mainleftcustomer.vue?vue&type=script&lang=js&"
export * from "./mainleftcustomer.vue?vue&type=script&lang=js&"
import style0 from "./mainleftcustomer.vue?vue&type=style&index=0&id=310d287c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310d287c",
  null
  
)

export default component.exports